
<template>
	<div ref="listWrap">
		<wrapper-list
      @add="paasAddPage"
	    @edit="paasEidtPage"
        @calculate="paasCalculate"      
		ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
          <row class="list-query-row">
          <FormItem label="快递公司" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_name" placeholder=""
              @on-change="queryTableDatas" clearable />
          </FormItem>
          </row>
      	</Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
        </wrapper-list>
   </div>
</template>
<script>
	import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@components/paas/cell-bar' //列表内操作
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,EnumShow  ,CellBar},
      data() {
      	return {
      		serviceUrl:"/eb/express",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
      		queryParam:{
   				query_LIKE_name:"",
                queryOrderBy_: 'sort@asc',
	        },
	         defaultLabelWidth:200,
	         tableColumns:[
	        	{
	              type: 'index',  //type: 'index'，可以排序
	              width: 40,
	              align: 'center',
	            },
	        	{
	        		title: '快递公司全称',
	        		key: 'name',
	        	},
	        	{
	        		title: '快递简称',
                    width:150,
	        		key: 'code',
	        	},
                 {
                   title: '宝塔云快递编码',
                   key: 'nyseCode',
                 },
	        	{
	        		title: '排序',
	        		key: 'sort',
	        	},
	        	{
	        		title: '是否显示',
	        		key: 'isShow',
	        		render:(h,params)=> {
                    if (params.row.isShow === "yes") {
                      return h("Icon", {
                        props: {
                          type: "md-checkmark"
                        },
                        style: {
                          color: "#0092DC"
                        }
                      })
                    } else {
                      return h("Icon", {
                        props: {
                          type: "md-close"
                        },
                        style: {
                          color: "#ed5565"
                        }
                      })
                    }
                  }
	        	},
	        	{	
	        		title: '操作',
	        		render: (h, params) => {
		                return h(CellBar,
		                    {
			                  props:{
			                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
			                  },
			                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
			                    on: {
			                      // 子组件$emit传递函数,必须是箭头函数写法
			                      'delete':()=>{
			                        this.$nextTick(()=>{
			                          this.paasDeleteOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                      'edit': ()=> {
			                        this.$nextTick(()=>{
			                          this.paasEditOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                    }
			                }
			            )
		            }
		         }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
      }
    } 
</script>
